export const engagementSegmentsCampaignSentenceAppGroupId = "/engagement/segments/campaign_sentence/:app_group_id";
